export default {
  selectedOrganisation: state => state.selectedOrganisation
}
